import React from 'react';
import { AlertTriangle, Clock, CheckCircle, XCircle } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import './shared-analytics.css';

const AlertsAnalytics = () => {
  const alertsData = [
    { day: 'Mon', critical: 3, warning: 5, info: 2 },
    { day: 'Tue', critical: 1, warning: 7, info: 4 },
    { day: 'Wed', critical: 4, warning: 3, info: 6 },
    { day: 'Thu', critical: 2, warning: 8, info: 3 },
    { day: 'Fri', critical: 5, warning: 4, info: 5 },
    { day: 'Sat', critical: 1, warning: 6, info: 2 },
    { day: 'Sun', critical: 3, warning: 5, info: 4 }
  ];

  const activeAlerts = [
    { id: 1, patient: 'Patient 44', type: 'Critical', message: 'Medication adherence below 15%', time: '2 hours ago', status: 'open' },
    { id: 2, patient: 'Patient 48', type: 'Warning', message: 'Missed 3 consecutive doses', time: '4 hours ago', status: 'open' },
    { id: 3, patient: 'Patient 43', type: 'Critical', message: 'Device offline for 24+ hours', time: '1 day ago', status: 'acknowledged' },
    { id: 4, patient: 'Patient 46', type: 'Info', message: 'Medication refill needed soon', time: '6 hours ago', status: 'resolved' }
  ];

  return (
    <div className="alerts-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <AlertTriangle size={24} />
          </div>
          <div className="card-content">
            <h3>Active Alerts</h3>
            <div className="card-value">12</div>
            <div className="card-change negative">+3 since yesterday</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fffbeb', color: '#f59e0b' }}>
            <Clock size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Response Time</h3>
            <div className="card-value">2.3h</div>
            <div className="card-change positive">-30min improvement</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <CheckCircle size={24} />
          </div>
          <div className="card-content">
            <h3>Resolved Today</h3>
            <div className="card-value">8</div>
            <div className="card-change positive">+2 from yesterday</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <XCircle size={24} />
          </div>
          <div className="card-content">
            <h3>Critical Alerts</h3>
            <div className="card-value">4</div>
            <div className="card-change neutral">Same as yesterday</div>
          </div>
        </div>
      </div>

      <div className="chart-container">
        <div className="chart-header">
          <h3>Alert Trends - Last 7 Days</h3>
        </div>
        <div className="chart-content">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={alertsData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="day" stroke="#6b7280" />
              <YAxis stroke="#6b7280" />
              <Tooltip />
              <Bar dataKey="critical" stackId="a" fill="#dc2626" />
              <Bar dataKey="warning" stackId="a" fill="#f59e0b" />
              <Bar dataKey="info" stackId="a" fill="#3b82f6" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="alerts-list">
        <h3>Recent Alerts</h3>
        <div className="alerts-table">
          {activeAlerts.map((alert) => (
            <div key={alert.id} className={`alert-row ${alert.type.toLowerCase()}`}>
              <div className="alert-info">
                <div className="alert-header">
                  <span className="alert-patient">{alert.patient}</span>
                  <span className={`alert-type ${alert.type.toLowerCase()}`}>{alert.type}</span>
                </div>
                <div className="alert-message">{alert.message}</div>
                <div className="alert-time">{alert.time}</div>
              </div>
              <div className={`alert-status ${alert.status}`}>
                {alert.status}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlertsAnalytics;
